import axios from 'axios'
import { APP_BASE } from '@/config/appBase'

export default {
  getTokenWithBookId (bookId, token) {
    const getUrl = APP_BASE + '/api/logintoken?token=' + token + '&bookId=' + bookId
    return axios.post(getUrl)
      .then(response => response.data.token)
  }
}
